import BigNumber from 'bignumber.js';

import { useGetStakeTokenBalanceQuery } from 'modules/api/actions/getStakeTokenBalance';
import { DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS } from 'modules/api/const';
import { mapDataToUndefinedIfSkip } from 'modules/api/utils';
import { useConnection } from 'modules/auth/hooks/useConnection';
import { ZERO } from 'modules/common/const';
import { useGetLSPendingUnstakesQuery } from 'modules/liquidStaking/actions/getPendingUnstakes';

const MIN_DEPRECATED_LS_BALANCE = new BigNumber(0.1);

interface IUseHasDeprecatedLSTokenResult {
  hasTokens: boolean;
  hasPendingUnstakes: boolean;
  isLoading?: boolean;
}

export function useHasDeprecatedLSToken(): IUseHasDeprecatedLSTokenResult {
  const { isConnected, connectionKey, cacheTime } = useConnection();
  const {
    data: balance = ZERO,
    isLoading,
    isFetching,
  } = useGetStakeTokenBalanceQuery(
    { connectionKey, poolAddress: DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS },
    {
      skip: !isConnected,
      selectFromResult: mapDataToUndefinedIfSkip,
      refetchOnMountOrArgChange: cacheTime,
    },
  );

  const { data: poolUnstakes } = useGetLSPendingUnstakesQuery(
    { connectionKey, poolAddress: DEPRECATED_LIQUID_STAKING_TOKEN_ADDRESS },
    {
      skip: !isConnected,
      selectFromResult: mapDataToUndefinedIfSkip,
      refetchOnMountOrArgChange: cacheTime,
    },
  );

  return {
    hasTokens: balance.isGreaterThan(MIN_DEPRECATED_LS_BALANCE),
    hasPendingUnstakes: !!poolUnstakes?.length,
    isLoading: isLoading || isFetching,
  };
}
